import { Asset } from "@ugla-france/ugla-3d-library";
import ViewItem from "./ViewItem";
import styled from "styled-components";
import { useState } from "react";

interface ViewsPanelProps {
    views: string[];
    selectedView: string;
    onViewChange: (view: string) => void;
    getAssetForView: (view: string) => Asset | undefined;
}

const ViewsPanel : React.FC<ViewsPanelProps> = ({views, selectedView, onViewChange, getAssetForView}) => {
    const firstViewAsset = views.length > 0 ? getAssetForView(views[0]) : undefined;
    const firstViewThumbnail = firstViewAsset?.tags?.find((tag) => tag.key === "thumbnail_view")?.value || "";
    
    const [isPanelOpen, setIsPanelOpen] = useState(true);

    if (views.length === 0) {
        return null;
    }

    return (
        // <>
        // <ViewToogle onClick={() => setIsPanelOpen((prev) => !prev)}>
        //     {isPanelOpen ? "Fermer les vues" : "Vues disponibles"}
        // </ViewToogle>
        <ViewList isPanelOpen={isPanelOpen}>
            {
                views.map((view) => {
                    const asset = getAssetForView(view);
                    return (
                        <ViewItem
                            key={view}
                            view={view}
                            selected={view === selectedView}
                            thumbnail={asset?.tags?.find((tag) => tag.key === "thumbnail_view")?.value!}
                            onClick={() => onViewChange(view)}
                        />
                    );
                })
            }
            <ViewItem
                view="360"
                selected={selectedView === "360"}
                thumbnail={firstViewThumbnail}
                onClick={() => onViewChange("360")}
            />
        </ViewList>
        // </>
    )
}

const ViewList = styled.div<{ isPanelOpen: boolean }>`
    display: flex;
    flex-direction: column;
    position: absolute;
    align-items: flex-end;
    top: 3%;
    right: 0;
    width: fit-content;
    height: 100%;
    border-radius: 5px;
    transition: transform 0.3s ease;
    transform: ${({ isPanelOpen }) => (isPanelOpen ? "translateX(0)" : "translateX(100%)")};
`

const ViewToogle = styled.button`
    position: absolute;
    top: 1rem;
    width: 10rem;
    right: 1rem;
    z-index: 1400;
    color: white;
    border: none;
    border-radius: 15px;
    padding: 0.5rem 1rem;
    background: rgba(63, 63, 63, 0.3);
    word-break: keep-all;
    text-align: center;
    font-size: 0.9rem;
    font-family: Poppins-Medium, sans-serif;

    cursor: pointer;
    &:hover {
        background: rgba(0, 0, 0, 0.5);
    }
`

export default ViewsPanel;